import { mediaData } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20abstract%20composition%20with%20soft%20bokeh%20effect%2C%20film%20reel%20inspired%2C%20luxurious%20amber%20and%20cream%20tones%2C%20professional%20cinematography%20aesthetic%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Professional%20warm%20toned%20abstract%20composition%20with%20cinematic%20lighting%2C%20film%20texture%2C%20golden%20hour%20warmth%2C%20elegant%20amber%20and%20cream%20palette%2C%20shallow%20depth%20of%20field%2C%20premium%20look&width=800&height=500&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20warm%20abstract%20art%20with%20soft%20golden%20light%2C%20film%20grain%20texture%2C%20elegant%20terracotta%20and%20cream%20tones%2C%20professional%20film%20aesthetic%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Beautiful%20warm%20abstract%20composition%20with%20cinematic%20golden%20lighting%2C%20film%20reel%20aesthetic%2C%20amber%20honey%20and%20cream%20tones%2C%20professional%20cinematography%20style%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=media-04&orientation=landscape',
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {mediaData.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.items.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-video w-full overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}